/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
}

.qds-chevron {
  transform: scaleX(var(--qds-direction-factor, 1));
}

.qds-external {
  display: none;
}

.qds-icon {
  vertical-align: text-bottom;
  flex-shrink: 0;
}

.qds-standalone-link {
  align-items: center;
  border-radius: var(--qds-focus-border-radius);
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  print-color-adjust: exact;
  text-decoration: none;
  width: 100%;

  &[rel~='external'] > .qds-external {
    display: inline-block;
  }

  &:focus-visible {
    outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
  }

  &:hover,
  &:active,
  &:visited {
    text-decoration: underline;
  }

  &[data-importance='subdued'] {
    color: var(--qds-theme-link-subdued-default);

    &:hover {
      color: var(--qds-theme-link-subdued-hover);
    }

    &:active {
      color: var(--qds-theme-link-subdued-pressed);
    }

    &:visited {
      color: var(--qds-theme-link-subdued-visited);

      &:hover {
        color: var(
          --qds-theme-link-subdued-visited-hover,
          var(--qds-theme-link-subdued-visited)
        );
      }

      &:active {
        color: var(
          --qds-theme-link-subdued-visited-pressed,
          var(--qds-theme-link-subdued-visited)
        );
      }
    }
  }

  &[data-importance='standard'] {
    color: var(--qds-theme-link-standard-default);

    &:hover {
      color: var(--qds-theme-link-standard-hover);
    }

    &:active {
      color: var(--qds-theme-link-standard-pressed);
    }

    &:visited {
      color: var(--qds-theme-link-standard-visited);

      &:hover {
        color: var(
          --qds-theme-link-standard-visited-hover,
          var(--qds-theme-link-standard-visited)
        );
      }

      &:active {
        color: var(
          --qds-theme-link-standard-visited-pressed,
          var(--qds-theme-link-standard-visited)
        );
      }
    }
  }

  &[data-importance='emphasized'] {
    color: var(--qds-theme-link-emphasized-default);

    &:hover {
      color: var(--qds-theme-link-emphasized-hover);
    }

    &:active {
      color: var(--qds-theme-link-emphasized-pressed);
    }

    &:visited {
      color: var(--qds-theme-link-emphasized-visited);

      &:hover {
        color: var(
          --qds-theme-link-emphasized-visited-hover,
          var(--qds-theme-link-emphasized-visited)
        );
      }

      &:active {
        color: var(
          --qds-theme-link-emphasized-visited-pressed,
          var(--qds-theme-link-emphasized-visited)
        );
      }
    }
  }
}

[aria-disabled='true'] {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

[data-size='small'] {
  &.qds-icon {
    height: var(--qds-control-small-icon-size);
    margin-inline-start: var(--qds-control-small-gap-internal);
    width: var(--qds-control-small-icon-size);
  }

  &.qds-standalone-link {
    font: var(--qds-control-small-text);
    gap: var(--qds-control-small-gap-internal);
    height: var(--qds-control-small-height);
  }
}

[data-size='standard'] {
  &.qds-icon {
    height: var(--qds-control-standard-icon-size);
    margin-inline-start: var(--qds-control-standard-gap-internal);
    width: var(--qds-control-standard-icon-size);
  }

  &.qds-standalone-link {
    font: var(--qds-control-standard-text);
    gap: var(--qds-control-standard-gap-internal);
    height: var(--qds-control-standard-height);
  }
}

[data-size='large'] {
  &.qds-icon {
    height: var(--qds-control-large-icon-size);
    margin-inline-start: var(--qds-control-large-gap-internal);
    width: var(--qds-control-large-icon-size);
  }

  &.qds-standalone-link {
    font: var(--qds-control-large-text);
    gap: var(--qds-control-large-gap-internal);
    height: var(--qds-control-large-height);
  }
}
